'use strict';

bbw.directive.bbwSignin = function() {
    return {
        templateUrl: bbw.templateUrl('signin.html'),
        restrict: 'A',
        scope: {
            signinClass: '@bbwSignin',
            sameUrl: '=sameUrl'
        },
        controller: bbw.guest.SignInCtrl,
        controllerAs: 'ctrl',
        replace: true,
        link: angular.noop
    };
};
